import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { auth } from "../firebaseConfig";
import { signInWithEmailAndPassword, setPersistence, browserSessionPersistence, sendEmailVerification, signOut } from "firebase/auth";
import Swal from "sweetalert2";
import TextField from "@mui/material/TextField";
import { doc, updateDoc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";

function Login() {
  const location = useLocation();
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      await setPersistence(auth, browserSessionPersistence);

      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );

      const user = userCredential.user;

      if (!user.email?.toLowerCase().endsWith("@maranaaz.gov")) {
        await signOut(auth);

        await Swal.fire({
          icon: "error",
          title: "Unauthorized",
          text: "You must use a @maranaaz.gov email to log in.",
          confirmButtonColor: "#3085d6",
        });

        return;
      }

      await user.reload();

      const userDocRef = doc(db, "users", user.uid);
      const userDocSnap = await getDoc(userDocRef);

      if (!userDocSnap.exists()) {
        await signOut(auth);

        await Swal.fire({
          icon: "error",
          title: "User Not Found",
          text: "Your account is not properly set up.",
        });

        return;
      }

     // const userData = userDocSnap.data();

      if (!user.emailVerified) {
        await sendEmailVerification(user);

        await updateDoc(userDocRef, {
          verificationSent: true,
        });

        await signOut(auth);

        await Swal.fire({
          icon: "info",
          title: "Email Verification Sent",
          text: "Please verify your email before logging in. Email may take 1-5 minutes to arrive. Check your spam folder if you don't see it.",
          confirmButtonColor: "#3085d6",
        });

        return;
      }

      await updateDoc(userDocRef, {
        emailVerified: true,
      });

      navigate("/dashboard/page/1");

    } catch (error) {
      let message = "Something went wrong.";

      if (error.code === "auth/too-many-requests") {
        message =
          "Too many attempts. Please wait or verify your email before trying again.";
      } else if (error.code === "auth/invalid-credential") {
        message = "Incorrect email or password.";
      }

      await Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: message,
        confirmButtonColor: "#3085d6",
      });
    }
  };

  useEffect(() => {
    if (location.state?.email) {
      setEmail(location.state.email);
    }
  }, [location.state]);
  
  return (
    <div className="password-popup">
      <div className="auth-container">
        <h1 id="login-text" style={{marginTop: "-5px"}}>Log In</h1>
        <form className="auth-form" onSubmit={handleLogin} name="login-form">
          <TextField label="Email" id="email" type="email" placeholder="" value={email} autoComplete="email" onChange={(e) => setEmail(e.target.value)} required size="medium" sx={{
            "& .MuiInputLabel-root.Mui-focused": { color: "black" }, "& .MuiOutlinedInput-root": { "&.Mui-focused fieldset": { border: "1px solid black", color: "black"},}, }}/>
          <TextField label="Password" type="password" placeholder="" onChange={(e) => setPassword(e.target.value)} required size="medium" sx={{
            "& .MuiInputLabel-root.Mui-focused": { color: "black" }, "& .MuiOutlinedInput-root": { "&.Mui-focused fieldset": { border: "1px solid black", color: "black" },},}}/>
          <Link className="forgot-link" to="/forgot">Forgot Password?</Link>
          <button type="submit" className="auth-btn">Log In</button>
        </form>
      </div>
    </div>
  );
}

export default Login;
